import { CodeSurfer, CodeSurferColumns, Step } from "code-surfer";
import { Image, Notes, Head } from "mdx-deck";
import { nightOwl, vsDark, ultramin } from "@code-surfer/themes";
import { Prefecth } from "../../../../../../components/Prefecth";
import { Profile } from "../../../../../../components/Profile";
import { Board } from "../../../../../../components/Board";
import { Titles } from "../../../../../../components/Titles";
import { Kevin } from "../../../../../../components/Kevin";
import { ReactLogo } from "../../../../../../components/ReactLogo";
import { AaronProfile } from "../../../../../../components/AaronProfile";
import customTheme from "../../../../../../customTheme";
import kevincode from "../../../../../../kevincode.png";
import codehike from "../../../../../../images/codehike.png";
import codesurfer from "../../../../../../images/codesurfer.png";
import docussaurus from "../../../../../../images/docussaurus.png";
import gitnext from "../../../../../../images/gitnext.png";
import mdxdeck from "../../../../../../images/mdxdeck.png";
import next from "../../../../../../images/next.png";
import story from "../../../../../../images/story.png";
import webconainer from "../../../../../../images/webconainer.png";
import * as React from 'react';
export default {
  CodeSurfer: CodeSurfer,
  CodeSurferColumns: CodeSurferColumns,
  Step: Step,
  Image: Image,
  Notes: Notes,
  Head: Head,
  nightOwl: nightOwl,
  vsDark: vsDark,
  ultramin: ultramin,
  Prefecth: Prefecth,
  Profile: Profile,
  Board: Board,
  Titles: Titles,
  Kevin: Kevin,
  ReactLogo: ReactLogo,
  AaronProfile: AaronProfile,
  customTheme: customTheme,
  kevincode: kevincode,
  codehike: codehike,
  codesurfer: codesurfer,
  docussaurus: docussaurus,
  gitnext: gitnext,
  mdxdeck: mdxdeck,
  next: next,
  story: story,
  webconainer: webconainer,
  React: React
};